"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiosServerError = exports.AxiosError = void 0;
const errors_1 = require("../errors");
/**
 * An error thrown by axios made r with large fields removed and the original error converted
 * into an object with its config removed.
 */
class AxiosError extends errors_1.WrappedError {
}
exports.AxiosError = AxiosError;
/**
  * Axios error with only status, statusText and data response error fields and a smaller original
  * error.
  */
class AxiosServerError extends AxiosError {
    constructor(response, originalError) {
        super(`${response.status}: ${response.statusText} - ${JSON.stringify(response.data, null, 2)}`, originalError);
        this.status = response.status;
        this.statusText = response.statusText;
        this.data = response.data;
    }
}
exports.AxiosServerError = AxiosServerError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL2F4aW9zL2Vycm9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLHNDQUF5QztBQUt6Qzs7O0dBR0c7QUFDSCxNQUFhLFVBQVcsU0FBUSxxQkFBOEI7Q0FBRztBQUFqRSxnQ0FBaUU7QUFFakU7OztJQUdJO0FBQ0osTUFBYSxnQkFBaUIsU0FBUSxVQUFVO0lBSzlDLFlBQ0UsUUFBMEQsRUFDMUQsYUFBK0I7UUFFL0IsS0FBSyxDQUNILEdBQUcsUUFBUSxDQUFDLE1BQU0sS0FBSyxRQUFRLENBQUMsVUFBVSxNQUFNLElBQUksQ0FBQyxTQUFTLENBQUMsUUFBUSxDQUFDLElBQUksRUFBRSxJQUFJLEVBQUUsQ0FBQyxDQUFDLEVBQUUsRUFDeEYsYUFBYSxDQUNkLENBQUM7UUFDRixJQUFJLENBQUMsTUFBTSxHQUFHLFFBQVEsQ0FBQyxNQUFNLENBQUM7UUFDOUIsSUFBSSxDQUFDLFVBQVUsR0FBRyxRQUFRLENBQUMsVUFBVSxDQUFDO1FBQ3RDLElBQUksQ0FBQyxJQUFJLEdBQUcsUUFBUSxDQUFDLElBQUksQ0FBQztJQUM1QixDQUFDO0NBQ0Y7QUFqQkQsNENBaUJDIn0=